import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconActiveProps, IconRender } from '../types.ts';

const Lock = React.forwardRef<SVGSVGElement | null, IconActiveProps>(function Lock({ active, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M10.1782 16.2857C10.1782 15.2797 10.9937 14.4642 11.9997 14.4642C13.0056 14.4642 13.8211 15.2797 13.8211 16.2857C13.8211 17.2916 13.0056 18.1071 11.9997 18.1071C10.9937 18.1071 10.1782 17.2916 10.1782 16.2857Z'
          fill={active ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.1423 9.42852H17.7852C18.848 9.42852 19.7137 10.2933 19.7137 11.3571V20.3571C19.7137 21.4209 18.848 22.2857 17.7852 22.2857H6.21373C5.15088 22.2857 4.28516 21.4209 4.28516 20.3571V11.3571C4.28516 10.2933 5.15088 9.42852 6.21373 9.42852H6.85658V6.85709C6.85658 4.02073 9.16309 1.71423 11.9994 1.71423C14.8358 1.71423 17.1423 4.02073 17.1423 6.85709V9.42852ZM11.9994 3.42857C10.1085 3.42857 8.57092 4.96619 8.57092 6.85709V9.42852H15.428V6.85709C15.428 4.96619 13.8903 3.42857 11.9994 3.42857ZM11.9997 12.9642C10.1653 12.9642 8.67822 14.4513 8.67822 16.2857C8.67822 18.12 10.1653 19.6071 11.9997 19.6071C13.834 19.6071 15.3211 18.12 15.3211 16.2857C15.3211 14.4513 13.834 12.9642 11.9997 12.9642Z'
          fill={active ? 'transparent' : color}
        />
        {/* active */}
        <path
          d='M10.1782 16.2857C10.1782 15.2797 10.9937 14.4642 11.9997 14.4642C13.0056 14.4642 13.8211 15.2797 13.8211 16.2857C13.8211 17.2916 13.0056 18.1071 11.9997 18.1071C10.9937 18.1071 10.1782 17.2916 10.1782 16.2857Z'
          fill={active ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.57087 9.42852H17.7852C18.848 9.42852 19.7137 10.2934 19.7137 11.3571V20.3571C19.7137 21.4208 18.848 22.2857 17.7852 22.2857H6.21373C5.15087 22.2857 4.28516 21.4208 4.28516 20.3571V11.3571C4.28516 10.2934 5.15087 9.42852 6.21373 9.42852H6.85658V6.85709C6.85658 4.0208 9.16316 1.71423 11.9994 1.71423C14.8357 1.71423 17.1423 4.0208 17.1423 6.85709V7.21422C17.1423 7.49036 16.9184 7.71423 16.6423 7.71423H15.928C15.6519 7.71423 15.428 7.49036 15.428 7.21422V6.85709C15.428 4.96623 13.8903 3.42852 11.9994 3.42852C10.1086 3.42852 8.57087 4.96623 8.57087 6.85709V9.42852ZM11.9997 12.9642C10.1653 12.9642 8.67822 14.4513 8.67822 16.2857C8.67822 18.12 10.1653 19.6071 11.9997 19.6071C13.834 19.6071 15.3211 18.12 15.3211 16.2857C15.3211 14.4513 13.834 12.9642 11.9997 12.9642Z'
          fill={active ? color : 'transparent'}
        />
      </>
    ),
    [active],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'flash-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Lock;
